import { render, staticRenderFns } from "./Selector.vue?vue&type=template&id=008f2a35&"
import script from "./Selector.vue?vue&type=script&lang=js&"
export * from "./Selector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports